import React, { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import {
  getDownloadURL,
  getStorage,
  ref,
  uploadBytesResumable,
} from "firebase/storage";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { urtoast } from "../../../Layouts/CustomPopup/eventEmitter";
import { v4 as uuidv4 } from "uuid";
import DisplayFileProper from "../../../Common/FilesRelevent/DisplayFileProper";
import DownloadButton from "../../../Common/FilesRelevent/DownloadButton";
import AsteriskLabel from "../../../Common/AsteriskLabel";
import { isAllowedFile } from "../../../../assests/extention/fileextention";

const validImageTypes = ["image/jpeg", "image/png", "image/jpg"];
const validDocumentTypes = ["application/pdf"];
const MAX_FILE_LIMIT = 5;

export default function PortfolioImages({ formik, doctype }) {
  const [selectedFiles, setSelectedFiles] = useState([]);

  useEffect(() => {
    setSelectedFiles(formik?.values?.files || []);
  }, [formik]);

  const handleUpload = (files) => {
    if (doctype == 1) {
      if (!files[0].type.includes("image")) {
        urtoast("Only images are allowed", 2)
        return
      }
    }
    const activeCount = (selectedFiles || []).filter((f) => f.status != 3).length;
    if (activeCount + files.length > MAX_FILE_LIMIT) {
      urtoast(`You can upload maximum ${MAX_FILE_LIMIT} files.`, 2);
      return;
    }

    const uploadPromises = files.map((file) => {
      if (file.size > 10 * 1024 * 1024) {
        urtoast(`File size exceeds 10MB limit.`);
        return Promise.reject(new Error("File size exceeds limit."));
      }

      if (!isAllowedFile(file)) {
        urtoast("Unsupported file format. Please upload a valid file type.", 2);
        return Promise.reject(new Error("Unsupported file type."));
      }

      if (
        validImageTypes.includes(file.type) ||
        (doctype == 1 && validDocumentTypes.includes(file.type))
      ) {
        const uniqueId1 = uuidv4();
        const storageRef = ref(getStorage(), `/Category/${uniqueId1}_${file.name}`);
        const uploadTask = uploadBytesResumable(storageRef, file);
        return uploadTask
          .then(async () => {
            const url = await getDownloadURL(uploadTask.snapshot.ref);
            return { file: url, status: 1 }; // status 1 for uploaded
          })
          .catch((error) => {
            urtoast(`Error uploading ${file.name}: ${error.message}`);
            throw error;
          });
      } else {
        urtoast(`This file type is not supported`);
        return Promise.reject(new Error("Unsupported file type."));
      }
    });

    Promise.all(uploadPromises)
      .then((urls) => {
        const updatedFiles = [...selectedFiles, ...urls];
        setSelectedFiles(updatedFiles);
        formik.setFieldValue("files", updatedFiles);
      })
      .catch((error) => {
        console.error("Error uploading files: ", error);
      });
  };

  const onDrop = (acceptedFiles) => {
    handleUpload(acceptedFiles);
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  // 🗑️ FIXED: Delete handler with status 3 for backend
  const handleDeleteImage = (index) => {
    // Get active (non-deleted) files
    const activeFiles = selectedFiles.filter(item => item.status !== 3);

    // Get the file to delete from active files
    const fileToDelete = activeFiles[index];

    // Mark the file with status 3 in selectedFiles array
    const updatedFiles = selectedFiles.map(item =>
      item.file === fileToDelete.file ? { ...item, status: 3 } : item
    );

    setSelectedFiles(updatedFiles);
    formik.setFieldValue("files", updatedFiles);
  };

  // Active (non-deleted) files for UI
  const activeFiles = selectedFiles.filter(item => item.status !== 3);

  return (
    <div className="add-portfolio upload-item-images">
      <h6 className="skill-right file-attachment">
        {doctype == 1 ? "Upload Item Images " : "Add product media"} {doctype != 1 && <span> (Upload at least 1 file)</span>} <AsteriskLabel />
      </h6>
      <div className="col-md-5 p-0 ">
        {activeFiles.length === 0 ? (
          <div className="image-container">
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/file-upload.png`}
              className="cover-img w-100"
              alt="Certificate"
            />
          </div>
        ) : (
          activeFiles.map((item, index) => (
            <div key={index} className="image-container position-relative">
              <DisplayFileProper item={item} />
              {/* <DownloadButton file={item} /> */}
              <button
                type="button"
                className="delete-button position-absolute top-0 end-0 m-1"
                onClick={() => handleDeleteImage(index)}
              >
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/delete-icon.svg`}
                  alt="Delete"
                />
              </button>
            </div>
          ))
        )}
      </div>
      {formik.touched.files && formik.errors.files ? (
        <p style={{ color: "red" }}>{formik.errors.files}</p>
      ) : null}
      <div {...getRootProps({ className: "dropzone borderstylex" })}>
        <input {...getInputProps()} />
        {isDragActive ? (
          <p>Drop the files here...</p>
        ) : (
          <p>
            Drag and drop or <span>Browse Image</span>
          </p>
        )}
      </div>
      {
        doctype == 1 ? '' :
          <ul className="border-ul">
            <li>Images (JPG, PNG, JPEG up to 10MB)</li>
            <li>Documents (PDF, DOCX, XLSX, PPTX, ZIP upto 10MB)</li>
          </ul>
      }
    </div>
  );
}